<template>
    <div class="iframe-wrapper" v-show="showIframeButtons">
        <a v-if="link.length > 0" class="codelink open-pdf-link" v-bind:href="link" target="_blank">{{ "App.VAKHaku.IframePdf.OpenToNewTab" | translate}}</a>
        <span v-if="link.length > 0" class="codelink close-pdf" v-on:click="closeIframe()">{{ "App.VAKHaku.IframePdf.CloseIframe" | translate}}</span>
        <iframe :id="id" class="pdf-frame"></iframe>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"
    import EmbeddedPdfModel from "../models/embeddedPdfModel"

    @Component
    export default class IframePdf extends Vue {
        @Prop() readonly id!: string
        @Prop() readonly index!: string
        link: string = ""

        get showIframeButtons(): boolean {
            const values: Array<EmbeddedPdfModel> = this.$store.getters.embeddedPdfFiles
            for (let i = 0; i < values.length; i++) {
                if (values[i].index === this.index) {
                    this.link = values[i].pdfUrl
                    return true
                }
            }
            return false
        }

        closeIframe(): void {
            const values: Array<EmbeddedPdfModel> = [...this.$store.getters.embeddedPdfFiles]
            values.splice(values.findIndex(v => v.index === this.index), 1)
            this.$store.dispatch("setEmbeddedPdfFiles", values)
        }
    }
</script>

<style scoped>

    .iframe-wrapper {
        background-color: rgb(242, 244, 248);
        padding-top: 5px;
        min-width: 1000px;
    }

    iframe.pdf-frame {
        width: 100%;
        height: 850px;
        display: none;
    }

    .codelink {
        margin-bottom: 5px;
    }

    span.codelink {
        color: #026273;
        font-weight: 600;
        background-image: linear-gradient(#80C1C2 50%, #FFFFFF 50%);
        background-size: 0.125rem 0.333rem;
        background-position: 0px 1.15em;
        background-repeat: repeat-x;
        text-decoration: none;
        cursor: pointer;
        float: right;
    }

        span.codelink:hover {
            color: #026273;
            font-weight: 600;
            text-decoration: none;
            background-image: linear-gradient(#026273 50%, #FFFFFF 50%);
        }
</style>
